<section class="content-layout">
  <bw-action-article-legacy [brightsideWebFb]="config.analyticsAttributes()" [minHeight]="0">
    <div header-actions class="flex-row pointer" *ngIf="!config.pageHideBackButton">
      <bw-icon-legacy iconName="close" size="24" (click)="handleCloseAction()"></bw-icon-legacy>
    </div>
    <div *ngIf="config.pageTitle" header-title class="flex-row space-between flex-end">
      <typography-legacy title-medium class="mb-sm">{{ config.pageTitle | translate }}</typography-legacy>
    </div>

    <div content-section>
      <div class="flex-column space-center mb-xl">
        <bw-spinner-legacy></bw-spinner-legacy>
        <p *ngIf="config.pageSubTitle" text-large-semibold class="mb-sm">{{ config.pageSubTitle | translate }}</p>
        <typography-legacy *ngIf="config.pageBodyText" text-large-regular color="var(--secondary-text)">
          <p class="center" style="max-width: 432px">{{ config.pageBodyText | translate }}</p>
        </typography-legacy>
      </div>
    </div>
    <div footer-actions class="flex-row row-reverse"></div>
  </bw-action-article-legacy>
</section>
